import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

function AboutCard() {
  return (
    <Box sx={{ background: '#ffffff00', width: 'fit-content', maxWidth: '90%', marginLeft: 'auto', marginRight: 'auto' }}>
      <Card variant="outlined" sx={{ background: '#fffaf0eb', width: 'fit-content' }}>
        <CardContent sx={{ textAlign: 'center' }}>
          <Typography variant="h5">
            Bailey Bruketta
          </Typography>
          <Typography
            variant="h6"
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 1.5,
              lineHeight: 1,
              fontSize: '1.05rem',
              fontWeight: 300,
            }}
          >
            <Box component="span" sx={{ lineHeight: 1 }}>Software Engineer</Box>
            <Box
              component="span"
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: '#F17F2A',
                flexShrink: 0,
              }}
            />
            <Box component="span" sx={{ lineHeight: 1 }}>Chicago, IL</Box>
          </Typography>
          <Typography variant="h6" sx={{ fontStyle: 'italic' }}>
            Full-stack software engineer with several years of experience. Hobbyist game developer.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}

export default AboutCard;
